import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useLeadSubmit } from '../hooks/useLeadSubmit';
import { OpenHouseForm } from '../components/OpenHouseForm';
import { OpenHouseHeader, OpenHouseCard, OpenHouseThankYou } from '../components/openhouse/OpenHouseParts';
import { useSeo } from '../hooks/useSeo';

const RESET_MS = 4000;
const initialForm = { name: '', phone: '', email: '', workingWithAgent: 'no', preApproved: 'not_yet', timeframe: '0-3', smsConsent: true };

const toPayload = (form, property) => ({
  name: form.name,
  phone: form.phone,
  email: form.email,
  property_address: property,
  working_with_agent: form.workingWithAgent,
  pre_approved: form.preApproved,
  timeframe: form.timeframe,
  sms_consent: form.smsConsent,
});

export default function OpenHousePage() {
  useSeo({ title: 'Open House Sign-In | Jess Sells East Coast', description: 'Sign in to the open house with Jessica Burnette, REALTOR®.', path: '/open-house', jsonLd: null });
  const [params] = useSearchParams();
  const property = params.get('property') || '';
  const [form, setForm] = useState(initialForm);
  const { submitted, submitting, submit } = useLeadSubmit({
    endpoint: '/leads/open-house',
    errorLabel: 'open house sign-in',
    resetMs: RESET_MS,
    onSuccess: () => setForm(initialForm),
  });
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(toPayload(form, property));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#143160] via-[#1E4A86] to-[#143160] flex flex-col" data-testid="open-house-page">
      <OpenHouseHeader />
      <main className="flex-1 flex items-center justify-center px-4 pb-12">
        <OpenHouseCard property={property}>
          {submitted
            ? <OpenHouseThankYou name={form.name || 'guest'} />
            : <OpenHouseForm form={form} set={set} submitting={submitting} onSubmit={handleSubmit} />}
        </OpenHouseCard>
      </main>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}
